import { useState } from "react";
import { FieldProps } from "./types";
import { FormContainer } from "./FormContainer";
import { FieldLabel, Textarea } from "@braze/beacon-core";

export const RequiredTextArea = (props: FieldProps) => {
    const [invalid, setInvalid] = useState(true);

    return (
        <FormContainer>
            <FieldLabel label={props.name} status={invalid ? "danger" : "success"} statusText={props.name + " is required"}
                infoIconPopoverContent={props.info !== null ? props.info : ""}>
                <Textarea name={props.name} id="stacked-text-field-1" invalid={invalid} fullWidth onChange={(e) => {
                    if (!e.target.value) {
                        props.handleChange(e.target.value);
                        setInvalid(true);
                    }
                    else {
                        setInvalid(false);
                        props.handleChange(e.target.value);
                    }
                }} vSize="xl" />
            </FieldLabel>
        </FormContainer>
    )
}